// IMPORT TYPINGS
import { Module } from 'vuex/types';
import { RootState } from '@/@types/member';

interface State {
  totalItems: number;
}

// STORE MODULE
const TOTAL_ITEMS_STATE: Module<State, RootState> = {
  state: {
    totalItems: 0,
  },
  actions: {
    setTotalItems(context, totalItems) {
      context.commit('SET_TOTAL_ITEMS', totalItems);
    },
    resetTotalItems(context) {
      context.commit('SET_TOTAL_ITEMS', 0);
    },
  },
  mutations: {
    SET_TOTAL_ITEMS(state, totalItems) {
      state.totalItems = totalItems;
    },
  },
  getters: {
    totalItems(state) {
      return state.totalItems;
    },
  },
};

export default TOTAL_ITEMS_STATE;
